import * as React from "react";
import { TestResults } from "../Shared/PFTAPITypes";
import { ResultsGroupHeading } from "../Shared/ResultsGroupHeading";

export interface DlcoTestAcceptabilityTableProps {
    displayTechnicianAcceptability: boolean;
    isViewOnly: boolean;
    testResults: Array<TestResults>;
    onAcceptabilityChange: (testId: string, checked: boolean) => void;
}

export const DlcoTestAcceptabilityTable = ({ displayTechnicianAcceptability, isViewOnly, testResults, onAcceptabilityChange }: DlcoTestAcceptabilityTableProps) => {
    return (
        <>
            <ResultsGroupHeading resultsCount={testResults.length} title="Acceptability" />
            <tr>
                <td>Acceptable</td>
                {
                    testResults.map((tr) => {
                        return (
                            <td key={`OverreaderAcceptability${tr.TestId}`}>
                                <input disabled={isViewOnly}
                                    checked={tr.OverreaderAcceptability}
                                    type="checkbox"
                                    onChange={(e) => onAcceptabilityChange(tr.TestId, e.target.checked)}
                                />
                            </td>
                        );
                    })
                }
                <td></td>
            </tr>
            {displayTechnicianAcceptability ? <tr>
                <td>Technician Acceptability</td>
                {
                    testResults.map((tr) => {
                        return (
                            <td key={`TechnicianAcceptability${tr.TestId}`}>
                                <input disabled={true} readOnly={true}
                                    checked={tr.TechnicianAcceptability}
                                    type="checkbox"
                                />
                            </td>
                        );
                    })
                }
                <td></td>
            </tr> : null}

        </>
    );
}
